import tw, { styled } from 'twin.macro';

export const StyledComparisonCards = styled.div`
  ${tw`container`};
  ${tw`grid lg:grid-cols-2`}
  ${tw`gap-4`}
  ${tw`px-2 md:px-3 lg:px-0`}
`;
